<template>
  <BaseModal :isBaseModal="isOpen" @close="close">
    <template #header>
      <p class="login-modal__title">
        Let's log in
      </p>
    </template>

    <template #default>
      <div class="login-modal">
        <p class="login-modal__subtitle">
          To ensure that your order is not lost in the vastness of your mail, we suggest that you log in to the site to
          track your order 🤗
        </p>

        <div class="login-modal__field">
          <label>Email</label>
          <input type="email" class="login-modal__input" v-model="form.email" placeholder="Email" />
        </div>

        <div class="login-modal__field">
          <label>Password</label>
          <input type="text" class="login-modal__input" v-model="form.password" placeholder="Password" />
          <div v-if="isLogin" class="login-modal__note  rest__password">
            Enter your password or <span @click="handleReset">Reset your password</span>
          </div>
          <div v-else class="login-modal__note">
            You can change password)))

          </div>
        </div>

        <p v-if="loginError" class="errore" style="color: red; font-size: 14px; margin-top: -10px;">
          {{ loginError }}
        </p>

        <p v-if="message">
          {{ message }}
        </p>
      </div>
    </template>

    <template #footer>
      <div class="login-modal__buttons">
        <button class="login-modal__btn without" @click="handleSubmit">
          Next
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/UI/BaseModal'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: Auth_actions } = createNamespacedHelpers('auth')
const { mapActions: Actions_alerts } = createNamespacedHelpers('alerts')

export default {
  name: "AuthModal",
  components: {
    BaseModal,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    paymentInfo: {
      required: true,
    },
    isUserExist: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: {
        company_name: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: 'manager',
      },
      loginError: '',
      message: "",
      isLogin: false
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.initializeForm();
      }
    },
    'form.password': function (newVal) {
      this.form.password_confirmation = newVal;
    },
    isUserExist(newVal) {
      if (newVal) {
        this.isLogin = newVal;
      }
    }
  },
  mounted() {
    this.form.company_name = `random_company_${Math.floor(Math.random() * 900000000) + 100000000}`;
  },
  methods: {
    ...Auth_actions(['login', 'loginRetail', 'register', 'resetPassword']),
    ...Actions_alerts(['addAlert']),

    getPaymentInfoName(fullName) {
      const parts = fullName.trim().split(/\s+/);
      if (typeof fullName !== 'string' || parts.length === 0 || parts[0] === '') return { firstName: '', lastName: '' };

      const firstName = parts[0];
      const lastName = parts.slice(1).join(' ');
      return { firstName, lastName };
    },

    initializeForm() {
      const namePart = this.getPaymentInfoName(this.paymentInfo?.firstName).firstName || 'user';
      const randomDigits = Math.floor(100 + Math.random() * 900);
      const generatedPassword = `pretty${namePart}!${randomDigits}`;

      this.form.email = this.paymentInfo.email || '';
      this.form.password = generatedPassword;
      this.form.password_confirmation = generatedPassword;
      this.form.first_name = this.getPaymentInfoName(this.paymentInfo?.firstName).firstName;
      this.form.last_name = this.getPaymentInfoName(this.paymentInfo?.firstName).lastName;
    },

    close() {
      this.$emit('close');
    },

    async tryLogin() {
      const { email, password } = this.form;

      try {
        await this.loginRetail({
          email,
          password,
          country_iso_code: localStorage.getItem('country_iso_code'),
          remember: false,
        });
        this.close();
      } catch (e) {
        if (e.response && e.response.status === 401) {
          this.loginError = 'Неверный пароль или email';
          this.login({ email, password, remember: true });
        } else if (e.response && e.response.status === 422) {
          this.addAlert({ text: 'Email is incorrect', type: 'error' });
          this.login({ email, password, remember: true });
        } else {
          this.addAlert({ text: 'Unexpected error', type: 'error' });
        }
      }
    },

    async registerUser() {
      try {
        await this.register(this.form);
        this.close();
      } catch (e) {
        const err = e.response?.data;
        if (err?.message === "The given data was invalid." &&
          err.errors?.email?.includes("Поле с таким значением уже зарегистрировано")) {
          this.isLogin = true;
          this.loginError = 'A user with this email has already been registered'
        } else {
          this.tryLogin();
          this.addAlert({
            text: e.response ? e.response.data.message : 'Что-то пошло не так',
            type: 'error',
          });
        }
      }
    },
    handleReset() {
      if (this.form.email === "") return this.loginError = "Пожалуйста введите свою почту"
      this.resetPassword(this.form.email).then((res) => {
        this.isLogin = true
        this.form.password = ""
        this.message = "A temporary password has been emailed to you."
        this.addAlert({
          text: 'A temporary password has been emailed to you.',
          type: 'success',
          timeout: 5000
        });
      })
    },

    handleSubmit() {
      if (this.isLogin) {
        this.tryLogin();
      } else {
        this.registerUser();
      }
    }
  },
}
</script>

<style scoped lang="scss">
.login-modal__title {
  font-size: 24px;
  line-height: 32px;
  overflow-wrap: break-word;
  color: rgb(34, 34, 34);
  font-weight: 700;
  padding-top: 24px;
}

.login-modal {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px;

  &__subtitle {
    font-size: 14px;
    color: #333;
    line-height: 1.5;
  }

  &__field {
    display: flex;
    align-items: center;

    label {
      font-size: 14px;
      width: 100px;
      font-weight: 500;
      margin-bottom: 0px;
      height: fit-content;
    }
  }

  &__input {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 14px;
    background-color: #f8f8f8;
    max-width: 200px;
  }

  &__note {
    display: inline-block;
    width: 165px;
    color: rgb(136, 136, 136);
    margin-left: 10px;
    font-size: 14px;
    cursor: "pointer";


  }

  .rest__password span {
    display: inline;
    width: 165px;
    color: rgb(0, 0, 0);
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;
  }

  &__buttons {
    display: flex;
    gap: 12px;
    margin-top: 10px;
    padding: 0 16px;
    margin-bottom: 20px;
  }

  &__btn {
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    width: fit-content;

    &.without {
      background-color: #1f1f1f;
      color: #fff;
      border: none;
      font-size: 14px;
      font-weight: 500;
    }

    &.next {
      background-color: #fff;
      border: 1px solid #1f1f1f;
      color: #1f1f1f;
      font-size: 14px;
      font-weight: 500;
    }

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>